import { Fragment } from 'react'
import { EventType } from 'types/Event'

import { EventCardAdmin } from './components/eventCard'
import { Container } from './evenList.style'

interface Props {
    data: EventType[]
    onEdit: (data: any) => void
    onDelete: (id: any) => void
}

export const EventListAdmin = ({ data, onEdit, onDelete }: Props) => {
    const now = new Date()

    // Separate upcoming vs past events
    const upcoming = data
        .filter((e) => new Date(e.event_date) >= now)
        .sort((a, b) => new Date(a.event_date).getTime() - new Date(b.event_date).getTime()) // ascending

    const past = data
        .filter((e) => new Date(e.event_date) < now)
        .sort((a, b) => new Date(b.event_date).getTime() - new Date(a.event_date).getTime()) // descending

    const sortedData = [...upcoming, ...past]

    return (
        <Container>
            {sortedData.map((current) => (
                <Fragment key={current.event_id}>
                    <EventCardAdmin eventId={current.event_id} onEdit={onEdit} onDelete={onDelete} />
                </Fragment>
            ))}
        </Container>
    )
}
